import { Agreement } from "./agreement"
import { ITariff } from "../tariff/tariff.types"

export class AgreementDetailed extends Agreement {
  tariff: ITariff
  meterpointId?: number

  constructor(data: {
    id: number
    startDate: string
    endDate: string
    orderedDate: string | null
    isCancelled: boolean
    productName: string
    productCode: string
    juniferNumber: string
    tariff: ITariff
    meterpointId?: number
  }) {
    super(data)
    this.tariff = data.tariff
    this.meterpointId = data.meterpointId
  }
}
